import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M12,18h1.11l.78,7A1.15,1.15,0,0,0,15,26h2a1.15,1.15,0,0,0,1.11-1l.78-7H20a1.5,1.5,0,0,0,1.53-1.94L20,10a3,3,0,0,0-2.2-2.25l-.51,0a3,3,0,1,0-2.58,0l-.51,0A3,3,0,0,0,12,10l-1.53,6.06A1.5,1.5,0,0,0,12,18Z"/><path d="M21.42,22.31l-.22,2A18.26,18.26,0,0,1,27.66,26c-1.35.83-5.39,2-11.66,2S5.69,26.83,4.34,26a18.26,18.26,0,0,1,6.46-1.71l-.22-2C5.54,22.92,2,24.34,2,26c0,2.21,6.27,4,14,4s14-1.79,14-4C30,24.34,26.46,22.92,21.42,22.31Z"/>';
export var StreetViewSVG = function StreetViewSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
StreetViewSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(StreetViewSVG);